export default {
  SET_swaps_received(state, payload) {
    state.swaps_received = payload
  },
}
